


<div mat-dialog-content>
  <h1>{{data.title}}</h1>
  <p>{{data.subtitle}}</p>

  <mat-selection-list #web [multiple]="false">
    <mat-list-option (click)="setSelected(item)" *ngFor="let item of defaultData; let index = index" [value]="item">
      <mat-divider></mat-divider>
      <h1 *ngIf="data.type == 'web' || data.type == 'folder'">{{item.displayName || item.name}}</h1>
      <p  *ngIf="data.type == 'web'">{{item.url}}</p>
      <p  *ngIf="data.type == 'quiz'">{{item.data.name}}</p>
      <p *ngIf="data.type == 'lottery'">{{item.name}}</p>
      <mat-divider></mat-divider>    
    </mat-list-option>
  </mat-selection-list>



  <!-- <mat-selection-list #web *ngIf="data.type == 'quiz'" [multiple]="false">
    <mat-list-option (click)="setSelected(item)"  *ngFor="let item of defaultData; let index = index" [value]="item">
      <mat-divider></mat-divider>
      <p>{{item.name}}</p>
      <p>{{item.url}}</p>
      <mat-divider></mat-divider>    
    </mat-list-option>
  </mat-selection-list> -->

<!-- <section class="listContainer" *ngIf="data.type == 'web'">
  <div [ngClass]="{'selected':item.selected === true}" (click)="setSelected(item)"  *ngFor="let item of defaultData; let index = index">
    <p>{{item.name}}</p>
    <p>{{item.url}}</p>
  </div>
  </section>

<section class="listContainer" *ngIf="data.type == 'data'">
  <div [ngClass]="{'selected':item.selected === true}" (click)="setSelected(item)" *ngFor="let item of defaultData; let index = index">
    <p >{{item.data.name}}</p>
  </div>
</section> -->


</div>


<div mat-dialog-actions>

  <button mat-raised-button color="{{data.buttonColor}}" [mat-dialog-close]="data" cdkFocusInitial>{{data.buttonLabel}}</button>
  <button mat-raised-button color="primary" (click)="onNoClick()">{{'cancel' | translation}}</button>
</div>

